import { useAtom } from "jotai";
import React from "react";
import { merchantAtom } from "../store";

const Footer = () => {
  
  const [merchant] = useAtom(merchantAtom);

  return (
    <div className="footer-container">
    <footer className="contain-expand">
      <div>
        {/* <div className="footer-business-name-box">
          <p>{merchant?.companyName}</p>
        </div> */}

        <div className="address-box">
          <p>{merchant?.companyName} {merchant?.street}, {merchant?.state}</p>
          <p>powered by: <span className="footer-logo">Gov ECMS</span></p>
        </div>
      </div>
      {/* <p className="m-y1 item4">This Store is operated by</p>
      <div className="footer-bx-1 item1">
        <p className="m-y1">This Store is operated by</p>
        <p>powered by:</p>
        <p className="bold-text">Gov ECMS Webshop</p>
      </div>

      <div className="footer-bx-2 item2">
        <div className="circle"></div>
        <div className="rect-bx"></div>
      </div>

      <div className="footer-bx-3 item3">
        <div className="sub-bx">
          <div className="rect-bx"></div>
          <div className="circle"></div>
        </div>

        <div className="sub-bx">
          <div className="rect-bx"></div>
          <div className="circle"></div>
        </div>
      </div> */}

    </footer>
      </div>
  );
};

export default Footer;
